var React = require('react');

function EmailOutline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M32.9667 12.1014C32.8392 11.4685 32.2696 10.9836 31.5973 10.9836H8.40268C7.73198 10.9836 7.16821 11.4688 7.04583 12.1091L20 20.1095L32.9667 12.1014ZM32.9933 15.6927L20 23.7172L7.01841 15.6999L7.00671 29.6311C7.00671 30.3896 7.63833 31.0164 8.40268 31.0164H31.5973C32.3617 31.0164 32.9933 30.3896 32.9933 29.6311V15.6927ZM31.5973 8C34.0222 8 36 9.96258 36 12.3689V29.6311C36 32.0374 34.0222 34 31.5973 34H8.40268C5.97777 34 4 32.0374 4 29.6299L4.0145 12.3689C4.0145 9.96213 5.97818 8 8.40268 8H31.5973Z","fill":"white"}));
}

EmailOutline.defaultProps = {"viewBox":"0 0 40 40","fill":"none"};

module.exports = EmailOutline;

EmailOutline.default = EmailOutline;
